import React from 'react'

const SortToggle = ({ moveDoneToEnd, onToggleSort }) => {
  return (
    <div className="sort-toggle">
      <span>Move done things to end?</span>

      <button type="button" 
       className={moveDoneToEnd ? "toggle-button active" : "toggle-button"}
       onClick={onToggleSort}>
        <span className="toggle-circle" />
      </button>
    </div>
  )
}

export default SortToggle